'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n        font-family: "source-sans-pro",sans-serif;\n        font-size: ', ';\n        line-height: ', ';\n        color: ', '\n    '], ['\n        font-family: "source-sans-pro",sans-serif;\n        font-size: ', ';\n        line-height: ', ';\n        color: ', '\n    ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BodyCopy = function BodyCopy(_ref) {
    var children = _ref.children,
        paragraphType = _ref.paragraphType,
        paragraphText = _ref.paragraphText,
        paragraphColor = _ref.paragraphColor;


    var fontSize = void 0,
        lineHeight = void 0;

    if (!paragraphType) {
        fontSize = '16px';
        lineHeight = '27px';
    }

    if (paragraphType === "larger-intro") {
        fontSize = '22px';
        lineHeight = '33px';
    }

    if (paragraphType === "small") {
        fontSize = '14px';
        lineHeight = '22px';
    }

    if (paragraphType === "small-sm-line-height") {
        fontSize = '14px';
        lineHeight = '18px';
    }

    var StyledP = _styledComponents2.default.p(_templateObject, fontSize, lineHeight, paragraphColor ? paragraphColor : null);

    return _react2.default.createElement(
        StyledP,
        { className: 'body-copy-component' },
        paragraphText,
        children
    );
};

exports.default = BodyCopy;


//////////////////
// WEBPACK FOOTER
// ./~/pubweb-react-components/dist/components/Typography/BodyCopy.js
// module id = 131
// module chunks = 168707334958949